if (!customElements.get('sticky-product-info')) {
  customElements.define(
    'sticky-product-info',
    class StickyProductInfo extends HTMLElement {
      constructor() {
        super();
        this.variantChangeUnsubscriber = null;
        this.variantSelects = this.querySelector('variant-selects');
      }

      connectedCallback() {
        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          this.handleVariantChange.bind(this)
        );

        if (this.variantSelects) {
          this.variantSelects.addEventListener('change', this.onVariantChange.bind(this));
        }
      }

      disconnectedCallback() {
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      handleVariantChange({ data: { sectionId, html } }) {
        if (this.dataset.originalSection !== sectionId) return;

        const newStickyBar = html.getElementById(`sticky-bar-${sectionId}`);
        const currentStickyBar = this.closest('sticky-bar');

        if (newStickyBar && currentStickyBar) {
          currentStickyBar.innerHTML = newStickyBar.innerHTML;
        }
      }

      onVariantChange(event) {
        const selectedOptionValues = Array.from(
          this.variantSelects.querySelectorAll('select'),
          (select) => select.value
        );

        publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
          data: {
            event,
            target: this.variantSelects,
            selectedOptionValues
          }
        });
      }
    }
  );
}
